import { endOfDay, startOfDay } from 'date-fns';
import { Fragment } from 'src/app/interfaces/api/fragment';
import { Metric, MetricData } from "./metric";
import { Planning } from "./planning";

export const defaultTask: PlanningTask = {

    id: '',
    number: 0,
    text: "Nouvelle tâche",
    progress: 0,
    duration: 0,
    parent: 0,
    indent: 0,
    children: [],
    parentTask: null,
    startDate: startOfDay(new Date()).toISOString(),
    endDate: endOfDay(new Date()).toISOString(),
    firstUpdate: "",
    lastUpdate: "",
    doneDate: '',
    detections: [],
    fragments: [],
    metrics: [],
    metricData: undefined,
    planning: "",
    resources: [],
    target: '',
    type: '1',
    uuid: '',
    volume: 0,
    volumeProgress: 0.00,
    volumeText: '0.00',
    volumeProgressText: '',
    cost: 0,
    costProgress: 0,
    fragmentDbIds: [],
    _id: ''
}


export interface BuildingProcessItem {
    measure: number;
    progress: number;
    dayProgress: number;
    progressText: string;
    measureText: string;
    percentText: string;
    dayProgressText: string;
}

export interface BuildingProcess {
    wall: BuildingProcessItem;
    floor: BuildingProcessItem;
    column: BuildingProcessItem;
}

export interface DayProgress {
    done: number;
    progress: number;
    volumeText: string;
}

export interface Resource {
    resource_id?: string;
    value?: string;
    cost_by_unit?: string;
    text?: string;
    name?: string;
    unit?: string;
    defaultValue?: number;
    defaultCostByUnit?: number;
    type?: string;
    unitOfMeasure?: string;
}

export interface PlanningTask {
    _id?: string;
    id: string;
    number: number;
    start_date?: string | number;
    startDate?: string | number;
    endDate?: string | number;
    doneDate?: string | number;
    lastUpdate?: string | number;
    firstUpdate?: string | number;
    text: string;
    uuid?: string;
    duration?: number;
    end_date?: string | number;
    progress?: number;
    parent?: string | number;
    type?: string;
    percentComplete?: string;
    outlineNumber?: string;
    outlineLevel?: string;
    remainingDuration?: string;
    cost: number; // default: 0
    costProgress: number; // default: 0
    volume: number; // default: 0
    volumeProgress: number; // default: 0
    actualCost?: string;
    durationFormat?: string;
    work?: string;
    target?: string;
    uid?: string;
    fragmentDbIds?: number[]; // default: []
    resources?: Resource[];
    planning: Planning | string;
    fragments?: string[];
    // Planning view specific properties
    backgroundColor?: string;
    priority?: string;
    color?: string;
    left?: number;
    width?: number;
    lateWidth?: number;
    firstUpdateLeft?: number;
    firstUpdateWidth?: number;
    volumeText?: string;
    volumeProgressText?: string;
    detections?: any[];
    metrics?: Metric[];
    metricCount?: number;
    groupMetricCount?: number;
    metricData?: MetricData;
    index?: number;
    parentTask?: PlanningTask | null;
    children?: PlanningTask[];
    indent?: number;
    class?: string;
    hidden?: boolean;
    // Additional task properties
    status?: string;
    beginDate?: string | number;
    buildingProcess?: BuildingProcess;
    fragmentData?: any;
    dayProgress?: DayProgress;
    progressText?: string;
    z?: number;
    height?: number;
}

export interface PostTask {
    number: number;
    start_date?: string | number;
    startDate?: string | number;
    endDate?: string | number;
    doneDate?: string | number;
    lastUpdate?: string | number;
    firstUpdate?: string | number;
    text: string;
    uuid?: string;
    duration?: string;
    end_date?: string | number;
    progress?: string;
    parent?: string;
    type?: string;
    percentComplete?: string;
    outlineNumber?: string;
    outlineLevel?: string;
    remainingDuration?: string;
    cost?: number; // default: 0
    costProgress?: number; // default: 0
    volume?: number; // default: 0
    volumeProgress?: number; // default: 0
    actualCost?: string;
    durationFormat?: string;
    work?: string;
    target?: string;
    fragments?: (Fragment | string)[]; // default: []
    fragmentDbIds?: number[]; // default: []
    resources?: Resource[];
    planning: Planning | string;
    children?: [];
    parentTask?: PlanningTask | null;
}

export interface PutTask {
    id: string;
    number?: number;
    start_date?: string | number;
    startDate?: string | number;
    endDate?: string | number;
    doneDate?: string | number;
    lastUpdate?: string | number;
    firstUpdate?: string | number;
    text?: string;
    uuid?: string;
    duration?: string;
    end_date?: string | number;
    progress?: string;
    parent?: string;
    type?: string;
    percentComplete?: string;
    outlineNumber?: string;
    outlineLevel?: string;
    remainingDuration?: string;
    cost?: number;
    costProgress?: number;
    volume?: number;
    volumeProgress?: number;
    actualCost?: string;
    durationFormat?: string;
    work?: string;
    target?: string;
    fragments?: (Fragment | string)[];
    fragmentDbIds?: number[];
    resources?: Resource[];
    planning?: Planning | string;
}